import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

// Unable to use primary, and secondary colors from theme due to opacity settings
export const CopilotLineGraphPerformanceBar = () => {
  const language = useLanguage();
  return (
    <div id="performers-row" className="flex h-[2.5rem] rounded-b">
      <div className="flex bg-blue-1000 pl-[40px] w-[100%] rounded-b">
        <div className="flex w-[19%] h-full items-center bg-blue-1000">
          <div className="flex w-full items-center">
            <div className="text-white text-xs">
              {language.hiringCopilotPerformanceBarLowReadiness()}
            </div>
          </div>
        </div>
        <div className="grow bg-blue-700 bg-opacity-20" />
        <div className="grow bg-blue-700 bg-opacity-40" />
        <div className="flex w-[19%] h-full bg-blue-700 bg-opacity-60">
          <div className="flex w-full justify-center items-center">
            <div className="text-white text-xs">
              {language.hiringCopilotPerformanceBarAverageReadiness()}
            </div>
          </div>
        </div>
        <div className="grow bg-blue-700 bg-opacity-80" />
        <div className="grow bg-blue-700" />
        <div className="flex w-[23.75%] h-full bg-blue-600 rounded-br">
          <div className="flex w-full items-center justify-end px-3">
            <div className="text-white text-xs">
              {language.hiringCopilotPerformanceBarHighReadiness()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
